import { logWorkspace, requireUser, updateUserStatus } from '../..';
import * as Telecom from '@servicetitan/telecom-rtcs-client';
import { userStatsFromAgentStats } from '../../types/ServiceUser';
import appManager from '@app/appManager';
import {
  ServiceSessionEventType,
  ServiceSessionUserEvent,
} from '../../types/ServiceEvents';

/**
 * The wrapup complete event indicates the end of wrap-up time.
 * @param event
 */
async function handleAgentWrapupCompleted(
  event: Telecom.AgentWrapupCompletedEvent,
) {
  const user = await requireUser(event.agentId);
  logWorkspace('service:agent:wrapup_completed:' + user.name, event);

  user.available = event.available;
  user.availabilityState = '';
  user.wrapupTime = event.wrapupTotalMs;
  user.capacity = 1;
  user.stats = userStatsFromAgentStats(event.stats);

  // update our status. status can be changed again
  updateUserStatus(user.id, undefined, true);

  appManager.events.emit<ServiceSessionUserEvent>(
    ServiceSessionEventType.WRAPUP_COMPLETED,
    {
      sessionId: event.conversationId,
      sessionSid: event.conversationSid,
      agentId: event.agentId,
      userId: user.id,
    },
  );
}

export default handleAgentWrapupCompleted;
